// Listado de partidos abiertos de UN club: `/canchas/:clubId/partidos` (desde el botón "Partidos abiertos"
// de la ficha del club). Es una página aparte, no una pestaña: las pestañas de la ficha no cambian.
// Consume GET /api/app/open-matches?clubId= (misma respuesta que el listado entre clubes) y reutiliza
// OpenMatchCard; cada tarjeta lleva al detalle `/partidos/:id`. "Crear partido abierto" lleva a la ficha del club
// con `?crear=partido`, que reutiliza el flujo de reserva para crear el partido (T10).
import React, { useCallback, useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getClubByIdApi, getOpenMatchesApi } from "../../api/api";
import OpenMatchCard from "./components/OpenMatchCard";
import { MATCHES_PAGE_SIZE, createOpenMatchPath, normalizeOpenMatches } from "./openMatchesModel";
import "../reservas/reservas.css";

const ClubOpenMatches = () => {
	const { clubId } = useParams();
	const navigate = useNavigate();
	const [clubName, setClubName] = useState("");
	const [matches, setMatches] = useState([]);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(false);
	const [loading, setLoading] = useState(true);
	const [loadingMore, setLoadingMore] = useState(false);
	const [error, setError] = useState("");

	const load = useCallback(
		async (nextPage, append) => {
			try {
				append ? setLoadingMore(true) : setLoading(true);
				setError("");
				const res = await getOpenMatchesApi({ clubId, page: nextPage, limit: MATCHES_PAGE_SIZE });
				const data = normalizeOpenMatches(res);
				setMatches((prev) => (append ? [...prev, ...data.matches] : data.matches));
				setPage(data.page);
				setHasMore(data.hasMore);
			} catch (err) {
				setError(err?.response?.data?.message || "No pudimos cargar los partidos abiertos.");
			} finally {
				setLoading(false);
				setLoadingMore(false);
			}
		},
		[clubId],
	);

	useEffect(() => {
		load(1, false);
	}, [load]);

	// El nombre del club es solo decorativo: si falla, el listado igual se muestra.
	useEffect(() => {
		let active = true;
		(async () => {
			try {
				const res = await getClubByIdApi(clubId);
				if (active) setClubName(res?.data?.info?.club?.name || "");
			} catch (_) {}
		})();
		return () => {
			active = false;
		};
	}, [clubId]);

	return (
		<div className="reservas-root">
			<div className="wrap">
				<button type="button" className="r-btn-soft" onClick={() => navigate(`/canchas/${clubId}`)}>
					Volver al club
				</button>
				<h1 style={{ fontSize: 28, fontWeight: 800, margin: "16px 0 4px" }}>Partidos abiertos</h1>
				{clubName && <p style={{ color: "var(--zoco-gray-2)", marginBottom: 16 }}>{clubName}</p>}

				<div style={{ marginBottom: 20 }}>
					<button type="button" className="r-btn-primary" onClick={() => navigate(createOpenMatchPath(clubId))}>
						Crear partido abierto
					</button>
				</div>

				{error && <Alert variant="danger">{error}</Alert>}
				{loading ? (
					<div style={{ textAlign: "center", padding: "60px 0" }}>
						<Spinner animation="border" />
					</div>
				) : matches.length === 0 && !error ? (
					<p style={{ textAlign: "center", padding: "40px 0" }}>
						No hay partidos abiertos en este club por ahora.
					</p>
				) : (
					<>
						<div className="bars-grid">
							{matches.map((m) => (
								<OpenMatchCard
									key={String(m._id)}
									match={m}
									onOpen={(x) => navigate(`/partidos/${x._id}`)}
								/>
							))}
						</div>
						{hasMore && (
							<div className="canchas-load-more">
								<button
									type="button"
									className="r-btn-soft"
									disabled={loadingMore}
									onClick={() => load(page + 1, true)}
								>
									{loadingMore ? "Cargando…" : "Ver más partidos"}
								</button>
							</div>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default ClubOpenMatches;
